import type * as React from 'react';

import { menu } from './styles';

import { ContainerDefault } from '../../Containers';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const Menu = ({ children }: { children: React.ReactNode }) => <ContainerDefault className={menu}>{children}</ContainerDefault>;
